module.exports = __webpack_public_path__ + "static/home_galeria_5-011195171d28236d2e0d2d7b0e074af0.jpg";